export const DZYARZHYNSK_REVIEWS = [
  {
    content: 'Я раньше думала, что самые вкусные бургеры в Маке. После того, как попробовала ваши, больше в Мак не хожу',
    name: "Яна",
    date: "03.02.2024",
    stars: "5",
  },
  {
    content: 'Спасибо за отличную обратную связь. У вас лучшие суши в Дзержинске это точно. А пиццы мы любим тоже только ваши. ',
    name: "Наталия",
    date: "20.01.2024",
    stars: "5",
  },
  {
    content: 'Спасибо за отличную обратную связь. У вас лучшие суши в Дзержинске это точно. А пиццы мы любим тоже только ваши. ',
    name: "Анастасия",
    date: "20.12.2023",
    stars: "5",
  },
  {
    content: 'очень вкусно готовят, советую ',
    name: "илья",
    date: "08.12.2023",
    stars: "5",
  },
  {
    content: 'Всё очень понравилось!!! Всё вкусно, шикарно! Доставка порадовала, курьер очень вежливая и приветливая девушка! Одииин мааааленький косяк)) в наивкуснейшей пицце попался горошек черного перца, ещё и девушке, которая совсем не ест острое, но мы всё равно довольны, всё отлично! Спасибо!!! Вы лучшие !!!',
    name: "Алёна",
    date: "15.11.2023",
    stars: "5",
  },
  {
    content: 'Суши сет замечательный, очень вкусно, спасибо',
    name: "Анжелика",
    date: "30.09.2023",
    stars: "5",
  },
  {
    content: 'Брали сет "Прайм", все вкусно, спасибо большое)',
    name: "Ольга",
    date: "24.09.2023",
    stars: "5",
  },
  {
    content: 'Все быстро и вкусно. Выбираем только вас 🔥 Доставка быстрая и вежливая',
    name: "Кристина",
    date: "08.09.2023",
    stars: "5",
  },
  {
    content: 'Ребята, спасибо огромное за роллы, сет семейные, всё вкусно, качественно, так держать, продолжайте радовать нас своим трудом и желаем вам всег благ👍👍👍👍👍👍👍👍👍👍👍👍👍👍',
    name: "Виктория",
    date: "13.08.2023",
    stars: "5",
  },
  {
    content: 'Поке - отпад, спасибо. Пицца отличная. Начинки немного, но тесто - просто суперр. Вам надо хлеб печь)))',
    name: "Юлия",
    date: "12.08.2023",
    stars: "5",
  },
  {
    content: 'Все отлично, просто шик',
    name: "Юрий",
    date: "25.07.2023",
    stars: "5",
  },
  {
    content: 'Спасибо большое! Все очень вкусно.',
    name: "Анастасия",
    date: "25.07.2023",
    stars: "5",
  },
  {
    content: 'Все очень вкусно и хорошо всегда когда чего то хочется вредного заказываем с семьей спасибо😎',
    name: "Глеб",
    date: "16.07.2023",
    stars: "5",
  },
  {
    content: 'Замечательное обслуживание, спасибо за качество! Бургеры,пиццы потрясающие,всегда свежие овощи,вкуснейшее тесто,все горячее и аккуратно упаковано.Вежливый курьер и доставка всегда вовремя.',
    name: "Диана",
    date: "01.07.2023",
    stars: "5",
  },
  {
    content: 'Заказываем всегда только у вас!!! Все 🔥🔥🔥🔥',
    name: "Павел",
    date: "28.05.2023",
    stars: "5",
  },
  {
    content: 'Хочу сказать "спасибо". При первом заказе произошёл небольшой инцидент, который оставил осадок. Но мы получили обратную связь. И уже при следующем заказе в качестве компенсации нам подарили пиццу. Кафе настроено, чтобы каждый клиент остался доволен! Всегда получаешь обратную связь, что не может не радовать!',
    name: "Александр",
    date: "24.05.2023",
    stars: "5",
  },
  {
    content: "Всё очень вкусно, быстро и замечательная подача ☺️",
    name: "Наталия",
    date: "10.05.2023",
    stars: "5",
  },
  {
    content: "Всегда все очень вкусно и быстро! Очень вежливый и профессиональный персонал.",
    name: "Дмитрий",
    date: "28.04.2023",
    stars: "5",
  },
  {
    content: "Пицца просто класс!!!",
    name: "Максим",
    date: "25.04.2023",
    stars: "5",
  },
  {
    content: "Заказываю не в первый раз!Очень вкусно, быстро, качественно !Приятный персонал!Спасибо!",
    name: "Ольга",
    date: "16.04.2023",
    stars: "5",
  },
  {
    content: "Самая вкусная пицца 😍",
    name: "Любовь",
    date: "09.04.2023",
    stars: "5",
  },
  {
    content: "Пицца очень вкусная) тесто приятно удивило  (мягкое, без корочек на конце, не тонкое)\nБудем заказывать ещё, спасибо)",
    name: "Алина",
    date: "08.04.2023",
    stars: "5",
  },
  {
    content: "Очень вкусная пицца! Быстро приготовлена, тесто мягкое. Рекомендую.",
    name: "Наталья",
    date: "02.04.2023",
    stars: "5",
  },
  {
    content: "Заказываю еду из свое часто и мои знакомые тоже , нам нравится что все вкусно и быстро. Так же мне очень нравится что у вас очень приятные и приветливые сотрудники",
    name: "Татьяна",
    date: "31.03.2023",
    stars: "5",
  },
  {
    content: "Огромное спасибо за быструю доставку,вкусную и горячую пиццу.Вы мастера своего дела.Если заказы,то только здесь.",
    name: "Татьяна",
    date: "25.03.2023",
    stars: "5",
  },
  {
    content: "Всё очень вкусно, особенно картофель фри. Быстро, вкусно и недорого.",
    name: "Олег",
    date: "18.03.2023",
    stars: "5",
  },
  {
    content: "Спасибо большое, всё супер!",
    name: "Татьяна",
    date: "17.03.2023",
    stars: "5",
  },
  {
    content: "Всегда очень вкусно! Очень много заказывала и всегда очень вкусно! Жду расширение ассортимента.)",
    name: "Софья",
    date: "08.03.2023",
    stars: "5",
  },
  {
    content: "Молодцы!!!!!!!! Очень вкусно)",
    name: "Вадим",
    date: "26.02.2023",
    stars: "5",
  },
  {
    content: "Разочаровали на 14 февраля,заказ был сделан в 10 утра на 19.00 ,пришли и ждали ещё 45 минут .Суши вкусные вопросов нет)",
    name: "Наталья",
    date: "15.02.2023",
    stars: "5",
  },
  {
    content: "Благодарю коллектив и руководителя за грамотное разрешение спорных ситуаций. Рекомендую кафе. Спасибо за понимание.",
    name: "Юлия",
    date: "05.02.2023",
    stars: "5",
  },
  {
    content: "Было бы круто если бы вы добавили рейтинг на конкретный продукт (вид пиццы или вид суши).",
    name: "Максим",
    date: "05.01.2023",
    stars: "5",
  },
  {
    content: "Добрый день, заказывала детям в Дзержинске пиццу и картошку фри, доставка быстрая, дети сказали пицца божественна, очень вкусная, спасибо большое, будем еще заказывать!!",
    name: "Елена",
    date: "21.12.2022",
    stars: "5",
  },
  {
    content: "Лучшая пицца в Дзержинске, постаянно заказываю. Вчера еще решили попробовать сладкую пиццу. Было вкусно. Но настроение испортил волос в тесте. Надеюсь больше такого не повториться. А так все всегда на высоте",
    name: "Светлана",
    date: "15.12.2022",
    stars: "3",
  },
  {
    content: "Суши приехали теплые вместе с холодными ,маленькие ,граммовкам не соответствует,по вкусу неплохо",
    name: "Ксения",
    date: "01.12.2022",
    stars: "3",
  },
  {
    content: "Заказывал 2 раза пиццу и суши 2 набора, приезжало все теплое и доставка занимала около часа. Все заказанное выглядело очень схоже с тем что на сайте. Рекомендую",
    name: "Илья",
    date: "20.10.2022",
    stars: "5",
  },
  {
    content: "Все очень вкусно !",
    name: "Данила",
    date: "04.10.2022",
    stars: "5",
  },
  {
    content: "Самые вкусные пиццы в городе. А изюминка в пицце это сырный бортик🤞",
    name: "Ольга",
    date: "14.10.2022",
    stars: "4",
  },
  {
    content: "Всё очень вкусно",
    name: "Ян абазовский",
    date: "10.10.2022",
    stars: "4",
  },
  {
    content: "пицца обалденная👍",
    name: "Денис",
    date: "09.10.2022",
    stars: "4",
  },
  {
    content: "Привезли тёплую, быстро, вкусно",
    name: "Евгений",
    date: "26.09.2022",
    stars: "4",
  },
  {
    content: "Лучшая пиццa в городе!!!",
    name: "Ольга",
    date: "18.09.2022",
    stars: "4",
  },
  {
    content: "Всё очень вкусно!",
    name: "Тимофей",
    date: "02.09.2022",
    stars: "5",
  },
  {
    content: "Бургеры кайф, спасибо большое",
    name: "Валера",
    date: "28.08.2022",
    stars: "5",
  },
  {
    content:
      "Заказываем ,только у вас,иногда расстраивает,что заказ долговато ждать.",
    name: "Дмитрий",
    date: "12.08.2022",
    stars: "4",
  },
  {
    content:
      "Спасибо большое!!! Очень вкусная пицца!!! Мы ваши клиенты!!! Добавьте ещё вариант пиццы с каперсами, будем очень рады!!!!",
    name: "Ирина",
    date: "11.08.2022",
    stars: "5",
  },
  {
    content:
      "Приехали в отпуск в Боровое. Заказали сет Мама сегодня не готовит. Безумно вкусный сет,свежие суши. И очень быстрая доставка.",
    name: "Наталья",
    date: "21.06.2022",
    stars: "5",
  },
  {
    content:
      "Лучшая пицца, которую я когда-либо пробовала! Супермясная, сырный и грибной цыплёнок - в самое сердечко ❤️ А о сырных бортиках вообще можно складывать легенды)) Что уж говорить, если мои друзья специально из Минска приезжают в Своё кафе за пиццей) Огромное спасибо! Процветания Вашему бизнесу!",
    name: "Дарья",
    date: "08.06.2022",
    stars: "5",
  },
  {
    content:
      "Заказывали гавайскую пиццу и горячие роллы , роллы супер , а вот пицца расстроила , абсолютно безвкусная курица , кажется забыли посолить , к тесту претензий нет , но соли или специй явно не хватило. Единственное что хоть как-то спасало ситуацию это яркий вкус ананасов . Очень расстроились !",
    name: "Мария",
    date: "17.02.2022",
    stars: "5",
  },
  {
    content: "Всегда все вкусно!!",
    name: "Юрий",
    date: "14.02.2022",
    stars: "5",
  },
  {
    content:
      "Очень понравилось.Все очень свежее и вкусное.Вся семья оценила.Теперь будем заказывать только у вас 🥰",
    name: "Ксения",
    date: "13.02.2022",
    stars: "5",
  },
  {
    content:
      "Все всегда очень вкусно, особенно пицца и гамбургеры. Доставка в срок. Один минус: привозят все подостывшее.",
    name: "Виктория",
    date: "04.02.2022",
    stars: "5",
  },
  {
    content:
      "Рекомендую! Заказываем на праздники в офис. Очень свежие и вкусные суши. Молодцы! Процветания Вашему бизнесу.",
    name: "Алина",
    date: "03.01.2022",
    stars: "5",
  },
  {
    content:
      "Спасибо огромное за вкусную пиццу и шикарное поздравление  ко Дню учителя",
    name: "Ольга",
    date: "07.11.2021",
    stars: "5",
  },
  {
    content:
      "Спасибо огромное, за суши. Заказывала на день рождения. Доставили оперативно, четко. Суши- супер!!! Буду обращаться ещё!!!",
    name: "Татьяна",
    date: "09.10.2021",
    stars: "5",
  },
  {
    content:
      'Сегодня впервые протестили вашу пиццу "Овощи и  грибы"-шикарнейшее тесто в ней и очень сбалансированный вкус всех ингридиентов-получили огромное гастрономическое удовольствие, благодарим!',
    name: "Наталья",
    date: "06.10.2021",
    stars: "5",
  },
  {
    content:
      "Очень круто, искал почти час нормальный сервис, в одном даже скинули трубку телефона, я нашёл это, 1)очень вежливо 2)спрашивают время за которое надо привести еду 3)мне нравится! 🅰️🅱️🅾️🅱️🆚😄😄😄😋",
    name: "Иван",
    date: "30.08.2021",
    stars: "5",
  },
  {
    content:
      "Отличное кафе! Рада была найти место с горячей едой в пол 9-го вечера в Дзержинске, здорово, что вы появились! Заказывала горячие суши с лососем и авакадо, приготовили быстро, вежливое обслуживание, роллы вкусные, ничем не хуже столичных.",
    name: "Диана",
    date: "11.08.2021",
    stars: "5",
  },
  {
    content:
      "Спасибо, что Вы у нас появились!!!\nПиццы,суши,бургеры,соусы-супер! С момента открытия постоянные клиенты по суши и пиццам!!! Все очень аккуратно,красиво, персонал приятный и самое главное все очень вкусное!!!\nМы с вами! Вы - лучшие!!!",
    name: "Полина",
    date: "28.07.2021",
    stars: "5",
  },
  {
    content:
      "Попробовали пиццу, огонь. Вкусная, легкое тесто, сочная.\n\nРоллы на высоте. Будем заказывать ещё:)",
    name: "Евгений",
    date: "27.07.2021",
    stars: "5",
  },
  {
    content:
      "Заказывали пиццу Карбонару и  Тейсти, все очень вкусно, съели даже корочки. \nСуши тоже очень вкусные, спасибо вам!\n10/10",
    name: "Анастасия",
    date: "27.07.2021",
    stars: "5",
  },
  {
    content: "Пицца вкусная и ароматная, суши достойные для хорошего вечера",
    name: "Алексей",
    date: "26.07.2021",
    stars: "5",
  },
  {
    content:
      'Заказали пиццу "супермясную", более вкусной пиццы мы нигде не встречали👍🔥👍 Ещё заказали картофель фри "улыбка" и куриные нагетсы для сына, он был просто в восторге. Спасибо вам за вкусную еду и оперативную доставку.🤗',
    name: "Елена",
    date: "20.07.2021",
    stars: "5",
  },
  {
    content: "Суши - бомба! Очень понравились,вкусные,буду заказывать ещё.",
    name: "Кристина",
    date: "20.07.2021",
    stars: "5",
  },
  {
    content: "Езжу к ним из Фаниполя.\nВсе очень вкусно.\nМолодцы.\nСпасибо",
    name: "Владимир",
    date: "11.07.2021",
    stars: "5",
  },
  {
    content:
      "Впервые сделала заказ в этом кафе. Осталась очень довольна. Начну с того, что заказ доставили точно в срок. Пицца приготовлена великолепно, брала Карбонаре и Маргариту, очень вкусные роллы.\nСпасибо огромное за обслуживание и прекрасную кухню.",
    name: "Наталья",
    date: "19.06.2021",
    stars: "5",
  },
  {
    content:
      'Собственно отзыв:\nВзял суши "сет для двоих"\nПо порядку:\n1. Ролл Спайси\nСурими в кляре - крабовая палочка, сыр замечен не был (или это сыр или это спайси соус) но на вкус это шлак. Однозначно 0 из 5 это не суши а хрень какая-то. \n2. Ролл с опаленным окунем\nСобственно окунь - в нём нету вкуса от слова совсем, капнули сверху острым соусом по типу "Сайгон" (это единственное что я там почувствовал). Яблоко сыр рис - прикольно, но это не окунь. Больше никогда их брать не буду.  1 из 5\n3. Ролл с имбирем и такуваном. Чтоб уважаемый клиент знал, такуван - это маринованая редька. Сочетание редьки и имбиря крутое (на любителя). Окунь жареный - см. выше про окуня вкуса нет от слова совсем. На фото его кстати больше, в реальности в ролле  помидор, сыр и милипиздрический кусочек окунька. Расчёт на то, что ты, мой дорогой читатель не разберешь ничего и съешь. 1 из 5 (редька с имбирём найс)\n4. Грин-ролл\nТут без вопросов 5 из 5. Вкусно. Советую, сочетание как надо. (не добавляйте имбирь и вассаби)\n5. Ролл филадельфия с огурцом. Жадность - первое что пришло в голову. Продавец никого не обманывает, на картинке действительно рыбы ровно на половину ролла. Огурца больше чем сыра. Мелкие. 3 из 5. \n6. Ролл запеченный с угрем\nна любителя. Они нормальные, но я больше их брать точно не буду. \n\nИтог - 50 рублей потрачены зря (сет никакой) (П. С. пиццы у заведения огонь. Тесто шикарное)',
    name: "Арсений",
    date: "19.06.2021",
    stars: "2",
  },
  {
    content:
      "Второй раз заказываем пиццу с овощами. Очень вкусная, сыр тянется, овощи свежие, тесто мягкое и эластичное, идеальная прожарка. Даже корочки съели :) Вот только жаль столов нет в кафе. Забрали и пиццу и пошли есть на улице... Поэтому 4 звезды, вкус все оправдывает. Вернусь когда будут столы",
    name: "Алиса",
    date: "07.06.2021",
    stars: "4",
  },
  {
    content:
      "Хочу выразить огромную благарность вашему кафе.\nВаши суши на высшем уровне.\nТак же хочется поблагодарить вашего администратора, Наталью. Очень приятная и вежливая девушка. Было очень приятно оформлять заказ, посоветовала по роллам, так как первый раз заказывал, жене очень понравились!  Вообщем мы в восторге! Будем дальше продолжать заказывать! И по больше бы таких работников(это редкость в наше время)",
    name: "Кирилл",
    date: "25.05.2021",
    stars: "5",
  },
  {
    content:
      "Все очень вкусно, свежие роллы, заказ сделали, и через 25 минут забрали! Больше вам спасибо",
    name: "Александра",
    date: "30.05.2021",
    stars: "5",
  },
  {
    content: "Доброго денёчка! Спасибо за вкусняшки! Обожаю свое кафе!",
    name: "Евгеша",
    date: "24.05.2021",
    stars: "5",
  },
  {
    content:
      "Как всегда на высшем уровне. Огромное спасибо за вашу работу. Всё очень вкусно и быстро.",
    name: "Наталья",
    date: "24.05.2021",
    stars: "5",
  },
  {
    content: "Очень вкусные и недорогие суши! Спасибо!)",
    name: "Егор",
    date: "24.05.2021",
    stars: "5",
  },
  {
    content: "Крутое место, нереально вкусная еда. Суши и пицца-пушка!",
    name: "Полина",
    date: "24.05.2021",
    stars: "5",
  },
  {
    content:
      "Любим заказывать пиццу и суши в данном кафе😊 Очень вкусно! Советуем всем",
    name: "Юлия",
    date: "23.05.2021",
    stars: "5",
  },
  {
    content:
      "Всем привет . Отзыв с пылу с жару 🔥 приняли заказ на сайте мгновенно . Привезли быстро . Карточкой рассчитали . Четко . Все аккуратно . Пицца мясная понравилась 👌🏼 Суши заказывали, тоже отличный вкусный сет . Спасибо , что вы есть 👍🏻",
    name: "Анастасия",
    date: "15.05.2021",
    stars: "5",
  },
  {
    content:
      "Хочу выразить огромную благодарность директору заведения своё кафе- Станиславу. При возникновений маленькой конфликтной ситуации с моей стороны он среагировал и быстро решил проблему. Сказать, что я была шокирована- ничего не сказать. Такому руководителю хочется пожелать классных сотрудников и процветания дела.\nПс жду уже когда вы сделаете в кафе посадку. А то мне на фрилансе работать в дзержике негде ) и запечённые суши- пушка бомба🔥",
    name: "Алёна",
    date: "15.05.2021",
    stars: "5",
  },
  {
    content: "Пиццы пушка, горячие суши огонь💪🏻",
    name: "Вадим",
    date: "12.05.2021",
    stars: "5",
  },
  {
    content:
      "Я кореец. Здесь очень вкусная пицца! И что самое главное, персонал очень приветливый",
    name: "Сангджин",
    date: "12.05.2021",
    stars: "5",
  },
  {
    content:
      "Суши и бургер очень понравились ,лучшие в Дзержинске. Доставка огонь",
    name: "Алеся",
    date: "28.04.2021",
    stars: "5",
  },
  {
    content:
      "Хочу поблагодарить за качественное обслуживание и вкусную еду. Заказывали большую пиццу. Столько начинки... Я была приятна удивлена. Вкусная, сочная😋Также очень понравились суши. Не смотря на то, как я отношусь равнодушно к ним. Мои вкусовые рецепторы были в восторге. Рекомендую 💯",
    name: "Мария",
    date: "26.04.2021",
    stars: "5",
  },
  {
    content:
      "Заказал пиццу сделали быстро и очень вкусно спасибо вам большое!!!!!!!!!!",
    name: "Александр",
    date: "31.03.2021",
    stars: "5",
  },
  {
    content:
      "Заказывали на 8 марта, Сет Семейный. И что могу сказать, это отвал бошки😋очень вкусные, свежие. Сочетание продуктов, очень необычное. Но это не мешает, им быть такими вкусными. В общем будем заказывать ещё 🤗🤗🤗",
    name: "Юлия",
    date: "09.03.2021",
    stars: "5",
  },
  {
    content:
      "Заказывала 2 ролла на пробу и была очень приятно удивлена!\nРыба свежая, сыр вкусный, сочетания интересные, вот только рис странный, но это не критично\nУверена что буду заказывать ещё, спасибо!",
    name: "Александра",
    date: "24.02.2021",
    stars: "5",
  },
  {
    content:
      "Брали сет «Для двоих». Роллы свежие, вкусные. Доставили к нужному времени. Рекомендую. Спасибо.",
    name: "Александра",
    date: "19.02.2021",
    stars: "5",
  },
  {
    content:
      "Доброго времени суток)\nЗаказали сет Нори (с доставкой) отметили для себя только плюсы. \n1-приветлевый персонал\n2-четко, без опозданий привезли роллы (не менее вежливая курьер)\n3-ароматные ммммм\n4-упаковка\n5-свежие, очень вкусные, тающие во-рту роллы.\nБольшое спасибо, желаем вам оставаться на плаву и ни в коем случае не снижать свое качество🤗",
    name: "Антонина",
    date: "14.02.2021",
    stars: "5",
  },
  {
    content:
      "Спасибо большое за очень вкусные,главное, свежие, суши!\nБудем ещё заказывать",
    name: "Екатерина",
    date: "14.02.2021",
    stars: "5",
  },
  {
    content: "Спасибо большое за вкусные  суши. Обязательно будем заказывать",
    name: "Людмила",
    date: "07.02.2021",
    stars: "5",
  },
  {
    content:
      "Заказывали суши, очень вкусные👍  а главное свежие. Спасибо большое. Успехов вам. Будем заказывать еще)",
    name: "Ольга",
    date: "28.01.2021",
    stars: "5",
  },
  {
    content:
      "Спасибо большое за очень вкусные и, главное, свежие, суши!!!\nОбязательно будем заказывать ещё не раз!!!",
    name: "Лилия",
    date: "27.01.2021",
    stars: "5",
  },
];
